<template>
  <v-file-input
    v-model="internalFiles"
    :accept="allowedFileTypes"
    :label="label"
    :multiple="allowMultiple"
    outlined
    :rules="fileRules"
    dense
    small-chips
    @change="handleFileChange"
  ></v-file-input>
</template>

<script>
export default {
  name: "FileUploaderConexion",
  props: {
    value: { type: Array, default: () => [] },
    label: { type: String, default: "Archivos" },
  },
  data() {
    return {
      internalFiles: this.value,
      hasPDF: false,
      allowMultiple: true,
      allowedFileTypes: "image/*,.pdf",
    };
  },
  watch: {
    internalFiles(newVal) {
      this.$emit("input", newVal);
    },
  },
  computed: {
    fileRules() {
      return [
        (v) => this.validateFileCount(v) || "Cantidad de archivos incorrecta",
        (v) => this.validateFileSize(v) || "Los archivos deben ser menor a 5MB",
        (v) => this.validateFileType(v) || "Solo se permiten imágenes o PDFs",
      ];
    },
  },
  methods: {
    handleFileChange(files) {
      this.hasPDF = files
        ? files.some((f) => f && f.type === "application/pdf")
        : false;
      this.allowMultiple = !this.hasPDF;
    },
    validateFileCount(v) {
      if (!v || v.length === 0) return false;
      if (this.hasPDF) return v.length === 1;
      return v.length === 2;
    },
    validateFileSize(v) {
      if (!v) return true;
      return v.every((file) => file.size < 5000000);
    },
    validateFileType(v) {
      if (!v) return true;
      return v.every((file) => {
        if (!file || !file.type) return false;
        return (
          file.type.startsWith("image/") || file.type === "application/pdf"
        );
      });
    },
  },
};
</script>
